/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_Sponsor_And_RegisterInputs */



/**
* | output |
* | --- |
* | "Sponsor & Register" |
*
* @param {Vekn_Sponsor_And_RegisterInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_sponsor_and_register = /** @type {((inputs?: Vekn_Sponsor_And_RegisterInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Sponsor_And_RegisterInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Parrainer & Inscrire")
	if (locale === "es") return /** @type {LocalizedString} */ ("Patrocinar e Inscribir")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Patrocinar & Inscrever")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sponsorizza & Iscrivi")
	return /** @type {LocalizedString} */ ("Sponsor & Register")
});